<template>
  <div class="public-top">
    <div class="top-color"></div>
    <div class="top-phone">
      <div class="phone-text">
        <div class="text-phone"><span class="phone-self">全国服务热线：(025) 5866 0838</span></div>
        <div style="display:flex;align-items:center;">
          <span class="text-login" @click="login" v-if="!user || !user.name">登录</span>
          <div v-else>
            <client-only>
              <el-popconfirm  :hide-icon="true" confirm-button-text='退出' confirm-button-type="text" icon="el-icon-info" title="确定要退出登录吗？" @confirm="logout">
                <span class="text-login" slot="reference">{{ user.name }}</span>
              </el-popconfirm>
            </client-only>
          </div>
          <div id="google_translate_element" style="float:left;margin-left:10px;"></div>
        </div>
      </div>
    </div>
    <div class="top-search">
      <img class="search-logo" src="~@/assets/images/top-logo.png" alt="">
      <client-only>
        <div class="search-ipt">
          <el-select class="search-select" v-model="searchType" slot="prepend" placeholder="学校">
            <el-option label="学校" value="1"></el-option>
            <el-option label="专业" value="2"></el-option>
            <el-option label="新闻" value="3"></el-option>
          </el-select>
          <input class="ipt-self" v-model="keywords" type="text" placeholder="学校 专业 新闻" />
          <div class="search-btn" @click="search"></div>
        </div>
      </client-only>
      <div class="search-code">
        <div class="code-list">
          <img class="code-img" src="~@/assets/images/top-qiwei-code.png" alt="">
          <p class="code-text">企微</p>
        </div>
        <div class="code-list">
          <img class="code-img" src="~@/assets/images/top-zixun-code.png" alt="">
          <p class="code-text">专属咨询顾问</p>
        </div>
      </div>
    </div>
    <div class="top-nav">
      <div class="nav-item">
        <div class="item-title"  @click="toggleDropdown">留学申请 <i class="title-icon"></i>
          <div class="dropdown-menu" v-show="isDropdownOpen">
            <div class="dropdown-content">
              <div class="dropdown-section">
                <h3>攻读学位</h3>
                <div class="dropdown-links">
                  <span class="dropdown-link" v-for="(item, index) in educationsOptions" :key="index" @click="goProductId('/product', item.id)">{{ item.name }}</span>
                </div>
              </div>
              <div class="dropdown-section">
                <h3>热门专业</h3>
                <div class="dropdown-links">
                  <span class="dropdown-link" v-for="(item, index) in productsOptions" :key="index" @click="goProduct('/product', item.cn_name)">{{ item.cn_name }}</span>
                </div>
              </div>
              <div class="dropdown-section">
                <h3>留学信息</h3>
                <div class="dropdown-links">
                  <span class="dropdown-link" @click="goPage('/advantage')" >留学优势</span>
                  <span class="dropdown-link" @click="goPage('/news/details', 1)" >QS排名</span>
                  <span class="dropdown-link" @click="goPage('/news/details', 2)" >留学费用</span>
                  <span class="dropdown-link" @click="goPage('/news/details', 3)" >内测考试</span>
                  <span class="dropdown-link"  @click="goPage('/success')">成功案例</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item-list">
          <p class="item-text" v-for="(item, index) in navList" :key="index" @click="goPage(item.url)" :class="{'active': item.url === url}" >{{item.title}}</p>
        </div>
      </div>
    </div>
    <div v-swiper:mySwiper="swiperOption" class="swiper-container" v-if="isShowSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(slide, index) in slideList" :key="index" >
          <img class="swiper-img" :src="slide.path" :alt="slide.name" @click="goHref(slide.href)" />
        </div>
      </div>
      <!-- 添加分页器 -->
      <div class="swiper-pagination" v-if="slideList.length > 1"></div>
    </div>
    <div class="show-nav" v-show="showFixedNav" :class="{ show: showFixedNav }">
      <div class="nav-item">
        <div class="item-title">
          <img class="title-logo" src="~@/assets/images/top-logo.png" alt="">
        </div>
        <div class="item-list">
          <p class="item-text" v-for="(item, index) in navList" :key="index" @click="goPage(item.url)" :class="{'active': item.url === url}" >{{item.title}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'public-top',
  props: {},
  data () {
    return {
      isDropdownOpen: false,
      isShowSwiper: true,
      slideList: [],
      url: '/',
      navList: [
        {
          title: '首页',
          url: '/',
        },
        {
          title: '国家介绍',
          url: '/countryIntroduction',
        },
        {
          title: '匈牙利大学',
          url: '/university',
        },
        {
          title: '匈牙利专业',
          url: '/product',
        },
        {
          title: '商务合作',
          url: '/cooperation',
        },
        {
          title: '新闻与活动',
          url: '/news',
        },
        {
          title: '申请',
          url: '/apply',
        },
        {
          title: '用户中心',
          url: '/user',
        }
      ],
      falseBanner: ['/user', '/product', '/advantage', '/success', '/visa', '/university/details', '/news/details', '/studyTour', '/apply'],
      type: 0, // 0: =>'首页', 1=>'国家介绍',2=>'匈牙利大学’,3=>'商务合作',4=>'新闻与活动'
      searchType: '1',
      keywords: '',
      productsOptions: [],
      educationsOptions: [],
      showFixedNav: false,
    }
  },
  components: {},
  computed: {
    user () { return this.$store.state.user || {} },
    swiperOption() {
    // 如果只有一张图片，则禁用轮播相关功能
      const isSingleSlide = this.slideList.length <= 1;
      return {
        loop: !isSingleSlide, // 只有在多张图片时才启用循环
        slidesPerView: 'auto',
        centeredSlides: !isSingleSlide, // 单张图片时居中
        spaceBetween: isSingleSlide ? 0 : 30, // 单张图片时无间距
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: isSingleSlide ? false : { // 单张图片时禁用自动播放
          delay: 3000,
          disableOnInteraction: false
        },
        // 禁用滑动操作（可选）
        allowTouchMove: !isSingleSlide
      }
    }
  },
  created () {
    this.getBanner()
    this.getProductsOptions()
    this.getEducationsOptions()
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        const pathArray = this.$route.path.split('/')
        this.url = pathArray.length > 1 ? '/' + pathArray[1] : '/'
        if (this.url === '/') {
          this.type = 0
        } else if (this.url === '/countryIntroduction') {
          this.type = 1
        } else if (this.url === '/university') {
          this.type = 2
        } else if (this.url === '/cooperation') {
          this.type = 3
        } else if (this.url === '/news') {
          this.type = 4
        }
        this.getBanner()
        if (this.falseBanner.includes(this.url) || this.falseBanner.includes(this.$route.path)) {
          this.isShowSwiper = false
        } else {
          this.isShowSwiper = true
        }
      }
    }
  },
  mounted () {
    if (process.browser) {
      window.addEventListener('scroll', this.handleScroll)
      window.googleTranslateElementInit = () => {
        if (window.google && window.google.translate) {
          new window.google.translate.TranslateElement({
            pageLanguage: 'zh-CN',
            includedLanguages: 'en,zh-TW,yue,th,vi,id,ms,lo,my,fil,tl,km,ne,hi,bn,ur,ta,ml,ja,ko,mn,uz,kk,tg,tk,ky,fa,fr,de,ru,es,pt,hu,uk,tr,la,pl,ar,af,zu,xh,kg,ln,lg,en-UG,rw,ha,ka,pcm,yo',
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
            autoDisplay: false,
            disableAutoTranslation: true
          }, 'google_translate_element');
        }
      }
      if (!document.getElementById('google-translate-script')) {
        const script = document.createElement('script');
        script.id = 'google-translate-script';
        script.type = 'text/javascript';
        script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
        document.body.appendChild(script);
      } else if (window.google && window.google.translate) {
        window.googleTranslateElementInit();
      }
    }
  },
  methods: {
    handleScroll() {
      const swiper = document.querySelector('.top-nav')
      if (!swiper) return
      const swiperTop = swiper.getBoundingClientRect().top + window.scrollY
      const scrollTop = window.scrollY

      // 滚动超过轮播图位置 → 显示固定导航
      if (scrollTop >= swiperTop - 50) {  
        this.showFixedNav = true
      } else {
        this.showFixedNav = false
      }
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    goPage (url, id) {
      if (id) {
        this.$router.push({
          path: url,
          query: {
            id: id
          }
        })
      } else { 
        this.$router.push(url)
      }
    },
    async getBanner () { 
      try { 
        let res = await this.$api.get('banners/lists?platform=1&type=' + this.type)
        if (res.code === 200 && res.data) { 
          this.slideList = res.data
          this.$nextTick(() => {
            if (this.mySwiper) {
              this.mySwiper.destroy(true, true)
              this.$nextTick(() => {
                // 重新初始化 Swiper
              })
            }
          })
        }
      } catch (error) {}
    },
    login() { 
      this.$store.commit('setShowLogin', true)
    },
    search () {
      let url = ''
      if (!this.keywords) {
        this.$message.error('请输入搜索内容')
        return false
      }
      if (this.searchType === '1') {
        url = '/university'
      } else if (this.searchType === '2') { 
        url = '/product'
      } else if (this.searchType === '3') { 
        url = '/news'
      }
      this.$router.push({
        path: url,
        query: {
          keywords: this.keywords
        }
      })
    },
    async getProductsOptions () { 
      try { 
        let res = await this.$api.get('products/lists?is_hot=1&is_home=1&home_position=1')
        if (res.code === 200 && res.data) { 
          this.productsOptions = res.data
        }
      } catch (error) {}
    },
    async getEducationsOptions () { 
      try { 
        let res = await this.$api.get('educations/options?is_product_show=1')
        if (res.code === 200 && res.data) { 
          for (let i in res.data) {
            let data = {
              id: i,
              name: res.data[i]
            }
            this.educationsOptions.push(data)
          }
        }
      } catch (error) {}
    },
    goProduct (url, keywords) {
      this.$router.push({
        path: url,
        query: {
          keywords: keywords
        }
      })
    },
    goProductId (url, id) {
      this.$router.push({
        path: url,
        query: {
          education_id: id
        }
      })
    },
    logout () {
      this.$store.dispatch('logout')
      this.$message.success('退出成功')
    },
    goHref (url) {
      if (url) { 
        window.open(url, '_blank')
      }
    }
  },
  destroyed() {
    if (process.browser) {
      window.removeEventListener('scroll', this.handleScroll)
    }
  },
}
</script>

<style scoped>
:deep(.el-input__inner){border:none;color:#198052;}
.el-select-dropdown__item.selected, .el-button--text{color:#198052 !important;}
.public-top{background-color:#fff;}
.top-color{height:10px;background:linear-gradient(to right, #cf676e 0%,#fae6e6 50%,#198052 100%);}
.public-top .top-phone{border-bottom:1px solid #e6e6e6;}
.public-top .top-phone .phone-text{max-width:1200px;width:100%;margin:0 auto;padding:10px 0;padding-left:54px;font-size:14px;color:#333;display: flex;justify-content:space-between;}
.public-top .top-phone .phone-text .text-login{cursor:pointer;color:#198052;padding:0 10px;background:url('~@/assets/images/logo-user.png') left center no-repeat;background-size:20px;padding-left:30px;line-height:30px;}
.public-top .top-phone .phone-text .text-phone{display:flex;gap:20px;}
.public-top .top-phone .phone-text .text-phone .phone-self{line-height:30px;}
.public-top .top-phone .phone-text .text-old{display:block;background-color:#198052;color:#fff;padding:0 20px;border-radius:4px;cursor:pointer;line-height:30px;}
.public-top .top-search{max-width:1200px;width:100%;margin:0 auto;display:flex;padding:34px 0;align-items: center;}
.public-top .top-search .search-logo{display:block;}
.public-top .top-search .search-ipt{flex:1;display:flex;justify-content:center;}
.public-top .top-search .search-select{border:2px solid #198052;border-right:none;padding-left:20px;padding-right:10px;outline:none;border-radius:45px 0 0 45px;color: #198052;font-size:16px;width:120px;}
.public-top .top-search .search-ipt .ipt-self{height:45px;width:400px;border:2px solid #198052;border-left:none;box-sizing:border-box;font-size:16px;padding:10px 20px;-webkit-tap-highlight-color: transparent;outline: none;}
.public-top .top-search .search-ipt .search-btn{height:45px;width:85px;background:#198052 url('~@/assets/images/top-search.png') center no-repeat;border-radius:0 45px 45px 0;cursor:pointer;background-size:26px;}
.public-top .top-search .search-code{display:flex;gap:26px;}
.public-top .top-search .code-img{display: block;width:76px;}
.public-top .top-search .code-text{font-size:12px;text-align:center;margin-top:5px;}
.public-top .top-nav{background-color:#198052;}
.public-top .top-nav .nav-item{max-width:1200px;width:100%;margin:0 auto;display:flex;padding:20px 0;color:#fff;font-weight:600;}
.public-top .top-nav .nav-item .item-title{font-size:18px;width:220px;padding:0 20px;align-items:center;display:flex;justify-content: space-between;position:relative;cursor:pointer;}
.public-top .top-nav .nav-item .item-title .title-icon{display:block;width:18px;height:18px;background:url('~@/assets/images/top-nav.png') center no-repeat;background-size:18px;flex-shrink:0;}
.public-top .top-nav .nav-item .item-list{display:grid;font-size:16px;grid-template-columns: repeat(8, 1fr);flex:1;cursor:pointer;padding-left:20px;text-align: center;}
.public-top .top-nav .nav-item .item-list .item-text.active{color:#FFEB3B;}
.public-top .top-nav .nav-item .item-list .item-text:hover{color:#FFEB3B;}
.dropdown-menu{position:absolute;top:46px;left:-54px;background: white;border: 4px solid #198052;border-top:none;border-radius:0 0 8px 8px;box-shadow: 0 4px 6px rgba(0,0,0,0.1);z-index:1000;width:300px;transition: all 0.3s ease;}
.dropdown-content{padding:20px;}
.dropdown-section {margin-bottom:20px;}
.dropdown-section h3 {font-size:16px;color:#333;margin-bottom:10px;}
.dropdown-links {display:flex;flex-wrap:wrap;gap:10px;}
.dropdown-link{font-size:14px;color:#333;cursor:pointer;padding:5px 10px;border-radius: 4px;transition: all 0.3s ease;font-weight:400;}
.dropdown-link:hover {background-color:#f0f0f0;color:#198052;}
.dropdown-menu::-webkit-scrollbar {width:6px;}
.dropdown-menu::-webkit-scrollbar-track {background: transparent;}
.dropdown-menu::-webkit-scrollbar-thumb {background: #198052;border-radius: 3px;}
.dropdown-menu::-webkit-scrollbar-thumb:hover {background: #198052;}
.swiper-img{display: block;width:100%;height:100%;cursor:pointer;}
.show-nav .nav-item{max-width:1200px;width:100%;margin:0 auto;display:flex;color:#333;font-weight:600;align-items:center;padding:0;}
.show-nav .nav-item .item-title{font-size:18px;width:220px;align-items:center;display:flex;justify-content: space-between;position:relative;cursor:pointer;}
.show-nav .nav-item .item-list{display:grid;font-size:16px;grid-template-columns: repeat(8, 1fr);flex:1;cursor:pointer;padding-left:20px;text-align: center;}
.show-nav .nav-item .item-list .item-text.active{color:#198052;}
.show-nav .nav-item .item-list .item-text:hover{color:#198052;}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0); /* 初始在上方100%位置，透明 */
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0); /* 最终回到正常位置，不透明 */
  }
}
/* 第二步：基础样式 + 动画控制 */
.show-nav {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  color: #333;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 10000;
  /* 默认隐藏 */
  opacity: 0;
  transform: translate3d(0, -100%, 0);
  pointer-events: none;
}
.show-nav.show {
  opacity: 1;
  transform: translate3d(0, 0, 0);
  pointer-events: auto;
  animation: fadeInDown 0.5s ease forwards;
}
@keyframes fadeOutUp {
  0% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}
/* 隐藏时触发反向动画 */
.show-nav:not(.show) {
  animation: fadeOutUp 0.5s ease forwards;
}
</style>
